/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import Logo from '../../components/dashboard/header/logo';
import Navigation from '../../components/dashboard/header/navigation';

const HeaderWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-right: 12px;
`;

const Header = () => (
    <HeaderWrapper>
        <Navigation/>
        <Logo/>
    </HeaderWrapper>
);

export default Header;



// WEBPACK FOOTER //
// ./src/containers/dashboard/header.js